

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { PatientAppointment } from '../patient-services/patient-appointment';
import { PatientRegistration } from '../patient-services/patient-registration';



export interface RadiologyEhrParameter extends Parameter {
  SearchTerm: number;
  OrderBy: string;

}

export interface RadiologyEhr {
  id?: any;
  regId: any;
  tenantId: any;
  branchId: any;
  containerName: string;
  fileLocation: string;
  fileName: string;
  category: string;
  doneDate: Date;
  doneBy?: string;
  fileAddedBy: string;
  referredBy?: string;
  isPregancyPatient?: string;
  gA_WeekWithDays?: string;
  notes: string;
  saveData?: string;
  modality?: string;
  tagType: string;
  metatags?: string;
  file?: any;
  billId?: any;
  isView?: any,
  isCreate?: any;
  isEdit?: any;
  fileAddedFrom?: string;
  userId?: any;
  workOrderId?: any;
  patientRegistrationMst?: PatientRegistration;
  parameters?: RadiologyEhrParameter[];
  links?: any;
  WorkOrderDetId?: any;
  tenant?: any;
  tenantBranch?: any;

  visitId?:string;
  regMst?:any;
  createdBy?:string;
}


export abstract class RadiologyEhrData {

  abstract list(url: string): Observable<RadiologyEhr[]>;
  //   abstract getDashboardData(url: string): Observable<any>;
  //   abstract getDashboardList(url: string): Observable<any[]>;
  abstract getById(url: string): Observable<any>;
  abstract get(url: string): Observable<any>;
  abstract create(url: string, data: any): Observable<any>;
  abstract createWithProgress(url: string, data:any): Observable<any> ;
  abstract update(url: string, data: RadiologyEhr): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
